import { contactDetails, siteLinks } from '../../content/siteContent';
import { InquiryForm } from '../components/InquiryForm';

export function ContactPage() {
  return (
    <>
      <header className="page-hero contact-hero">
        <p className="eyebrow">Keynotes · Workshops · Corporate Programs</p>
        <h1>Book Christina</h1>
        <p className="page-hero__lead">Tell us about the audience, the moment, and what you want people to carry forward.</p>
      </header>
      <section className="contact-grid">
        <div className="inquiry-intro">
          <p className="eyebrow">Speaking inquiries</p>
          <h2>Start the conversation.</h2>
          <p>The secure online inquiry form will collect event details and save them directly for Christina’s team.</p>
        </div>
        <address className="contact-card">
          <span>Email</span><a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a>
          <span>Health & education</span><a href={siteLinks.fivePhases}>5 Phases Health</a>
          <span>Newsletter</span><a href={siteLinks.newsletter}>Five Phases Health on Beehiiv</a>
        </address>
      </section>
      <section className="inquiry-section" aria-label="Speaking inquiry form">
        <InquiryForm />
      </section>
    </>
  );
}
